/**
 * プルダウンの末尾に置く「＋ 新しい〜を登録…」の値(ユーザー要望 2026-10-15)。
 * これが選ばれたら選択は変えず、登録のダイアログを開き、登録したものを選ぶ。
 */
export const CREATE_NEW = "__create_new__";
